import { AuthService } from '@sbe-spinoff-schoolbell-e/web-shared';
import { type CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { environment } from '../../environments/environment';

// schoolbell-e-web과 달리 이 앱엔 자체 로그인 화면이 없다 — 미로그인이면
// schoolbellEWebLoginUrl로 풀 페이지 리다이렉트하고, 그쪽 login.component.ts가
// ?return=<현재 URL>을 받아 로그인 성공 시 되돌려보낸다(2026-08-05
// developer-web-domain-separation 플랜, B안). app.config.ts의 restoreSessionOnBoot이 부팅
// 시점에 공유 refresh 쿠키로 세션 복원을 먼저 시도하므로, 이미 다른 곳에서 로그인해 둔
// 사용자는 대부분 이 리다이렉트를 보지 않는다.
export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  if (auth.isLoggedIn()) return true;
  const returnTo = encodeURIComponent(window.location.href);
  window.location.href = `${environment.schoolbellEWebLoginUrl}?return=${returnTo}`;
  return false;
};
